import React from 'react';
import { Target } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface MobileProgressFABProps {
  progress: number; // 0-100
  onClick: () => void;
  className?: string;
}

export function MobileProgressFAB({ progress, onClick, className }: MobileProgressFABProps) {
  // Calculate the stroke-dashoffset for the progress circle
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed bottom-6 right-6 z-50',
        'w-[60px] h-[60px] rounded-full',
        'bg-coral text-white shadow-lg',
        'flex items-center justify-center',
        'transition-all duration-200 ease-out',
        'hover:scale-110 active:scale-95',
        'focus:outline-none focus:ring-2 focus:ring-warning focus:ring-offset-2',
        'lg:hidden', // Only show on mobile/tablet
        className
      )}
      aria-label={`Profile completion: ${Math.round(progress)}%`}
    >
      {/* Progress Ring */}
      <svg
        className="absolute inset-0 w-full h-full -rotate-90"
        viewBox="0 0 48 48"
      >
        {/* Background circle */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          stroke="rgba(255, 255, 255, 0.2)"
          strokeWidth="2"
          fill="none"
        />
        {/* Progress circle */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          stroke="white"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-300 ease-out"
        />
      </svg>
      
      {/* Center Icon */}
      <div className="relative z-10">
        <Target className="w-6 h-6" />
      </div>
      
      {/* Progress Percentage (small text) */}
      <div className="absolute -bottom-1 -right-1 bg-white text-warning text-xs font-medium rounded-full w-6 h-6 flex items-center justify-center shadow-sm">
        {Math.round(progress)}
      </div>
    </button>
  );
}